import { useQuery, useMutation } from "@tanstack/react-query";
import apiAxiosInstance from "../../common/utilities/axios/apiAxiosInstance";


/** queries */

export const useGetClientAccPDByIdQuery = ({ clientAccountId }) => {
    return useQuery({
        queryKey: ['getClientAccPDByIdQuery', `${clientAccountId}`],
        queryFn: () => {
            // sleep(2000);
            return apiAxiosInstance
                .get(`/client-portal/Reports-Resources/report/getClientAccountProgramDecriptorsById/${clientAccountId}`)
                .then((res) => {
                    // console.log("gll-dataIn:", res.data)
                    return res.data
                })
        },
        // The query will not execute until the clientAccountId exists
        enabled: !!clientAccountId,
    })
}

/**Mutations */
export const useViewClientAccoundPDListMutation = () => {
    return useMutation({
        mutationFn: ({ loggedInUserId, roleId, isEnterpriseAdmin }) => {
            return apiAxiosInstance.post(`/client-portal/Reports-Resources/report/roleBasedGetAllClientAccountsForPD`, {
                "LoggedInUserId": loggedInUserId || "",
                "RoleId": roleId || "",
                "IsEnterpriseAdmin": isEnterpriseAdmin
            })
        },
    })
}

export const useGetFolderStructureForPDsByClientAccIdQuery = ({ clientAccountId }) => {
    return useQuery({
        queryKey: ['getFolderStructureForPDsByClientAccIdQuery', `${clientAccountId}`],
        queryFn: () => {
            // sleep(2000);
            return apiAxiosInstance
                .get(`/client-portal/Reports-Resources/report/getClientAccountResourceFolderById/${clientAccountId}`)
                .then((res) => {
                    // console.log("gll-dataIn:", res.data)
                    return res.data
                })
        },
        // The query will not execute until the clientAccountId exists
        enabled: !!clientAccountId,
    })
}

/**same API for Create and Update */
export const useCreateClientAccPDMutation = () => {
    return useMutation({
        mutationFn: ({ body }) => {
            return apiAxiosInstance.post(`/client-portal/Reports-Resources/report/createClientProgramDescriptorMapping`, body)
        },
    })
}

export const useCreateOrUpdateFolderStructureForPDsMutation = () => {
    return useMutation({
        mutationFn: ({ body }) => {
            return apiAxiosInstance.post(`/client-portal/Reports-Resources/report/createClientProgramDescriptorFolders`, body)
        },
    })
}